import { BrowserRouter, Routes, Route } from "react-router-dom";
import TaiNanHoGiaDinh from './pages/tai-nan-gia-dinh';
import GlobalState from "./context/globalState";

function App() {

  return (
    <BrowserRouter>
      <GlobalState>
        <Routes>
          <Route path={"*"} element={<TaiNanHoGiaDinh />} />
        </Routes>
      </GlobalState>
    </BrowserRouter>
  );
}

export default App;
